import { LaenderschluesselEnum } from '../v2024';

export const LaenderschluesselEnumLabels = {
    _660: '660' as LaenderschluesselEnum,
    _220: '220' as LaenderschluesselEnum,
    _070: '070' as LaenderschluesselEnum,
    _208: '208' as LaenderschluesselEnum,
    _457: '457' as LaenderschluesselEnum,
    _830: '830' as LaenderschluesselEnum,
    _832: '832' as LaenderschluesselEnum,
    _043: '043' as LaenderschluesselEnum,
    _330: '330' as LaenderschluesselEnum,
    _446: '446' as LaenderschluesselEnum,
    _891: '891' as LaenderschluesselEnum,
    _459: '459' as LaenderschluesselEnum,
    _310: '310' as LaenderschluesselEnum,
    _608: '608' as LaenderschluesselEnum,
    _528: '528' as LaenderschluesselEnum,
    _077: '077' as LaenderschluesselEnum,
    _474: '474' as LaenderschluesselEnum,
    _078: '078' as LaenderschluesselEnum,
    _334: '334' as LaenderschluesselEnum,
    _800: '800' as LaenderschluesselEnum,
    _802: '802' as LaenderschluesselEnum,
    _453: '453' as LaenderschluesselEnum,
    _640: '640' as LaenderschluesselEnum,
    _666: '666' as LaenderschluesselEnum,
    _469: '469' as LaenderschluesselEnum,
    _073: '073' as LaenderschluesselEnum,
    _017: '017' as LaenderschluesselEnum,
    _421: '421' as LaenderschluesselEnum,
    _284: '284' as LaenderschluesselEnum,
    _413: '413' as LaenderschluesselEnum,
    _625: '625' as LaenderschluesselEnum,
    _675: '675' as LaenderschluesselEnum,
    _516: '516' as LaenderschluesselEnum,
    _475: '475' as LaenderschluesselEnum,
    _093: '093' as LaenderschluesselEnum,
    _391: '391' as LaenderschluesselEnum,
    _892: '892' as LaenderschluesselEnum,
    _508: '508' as LaenderschluesselEnum,
    _468: '468' as LaenderschluesselEnum,
    _357: '357' as LaenderschluesselEnum,
    _703: '703' as LaenderschluesselEnum,
    _068: '068' as LaenderschluesselEnum,
    _236: '236' as LaenderschluesselEnum,
    _328: '328' as LaenderschluesselEnum,
    _021: '021' as LaenderschluesselEnum,
    _512: '512' as LaenderschluesselEnum,
    _720: '720' as LaenderschluesselEnum,
    _837: '837' as LaenderschluesselEnum,
    _436: '436' as LaenderschluesselEnum,
    _272: '272' as LaenderschluesselEnum,
    _477: '477' as LaenderschluesselEnum,
    _008: '008' as LaenderschluesselEnum,
    _724: '724' as LaenderschluesselEnum,
    _322: '322' as LaenderschluesselEnum,
    _460: '460' as LaenderschluesselEnum,
    _456: '456' as LaenderschluesselEnum,
    _338: '338' as LaenderschluesselEnum,
    _500: '500' as LaenderschluesselEnum,
    _096: '096' as LaenderschluesselEnum,
    _428: '428' as LaenderschluesselEnum,
    _336: '336' as LaenderschluesselEnum,
    _053: '053' as LaenderschluesselEnum,
    _529: '529' as LaenderschluesselEnum,
    _041: '041' as LaenderschluesselEnum,
    _815: '815' as LaenderschluesselEnum,
    _032: '032' as LaenderschluesselEnum,
    _823: '823' as LaenderschluesselEnum,
    _001: '001' as LaenderschluesselEnum,
    _894: '894' as LaenderschluesselEnum,
    _822: '822' as LaenderschluesselEnum,
    _314: '314' as LaenderschluesselEnum,
    _252: '252' as LaenderschluesselEnum,
    _076: '076' as LaenderschluesselEnum,
    _276: '276' as LaenderschluesselEnum,
    _044: '044' as LaenderschluesselEnum,
    _473: '473' as LaenderschluesselEnum,
    _009: '009' as LaenderschluesselEnum,
    _406: '406' as LaenderschluesselEnum,
    _831: '831' as LaenderschluesselEnum,
    _416: '416' as LaenderschluesselEnum,
    _107: '107' as LaenderschluesselEnum,
    _260: '260' as LaenderschluesselEnum,
    _257: '257' as LaenderschluesselEnum,
    _488: '488' as LaenderschluesselEnum,
    _452: '452' as LaenderschluesselEnum,
    _835: '835' as LaenderschluesselEnum,
    _424: '424' as LaenderschluesselEnum,
    _740: '740' as LaenderschluesselEnum,
    _664: '664' as LaenderschluesselEnum,
    _700: '700' as LaenderschluesselEnum,
    _109: '109' as LaenderschluesselEnum,
    _612: '612' as LaenderschluesselEnum,
    _007: '007' as LaenderschluesselEnum,
    _616: '616' as LaenderschluesselEnum,
    _024: '024' as LaenderschluesselEnum,
    _624: '624' as LaenderschluesselEnum,
    _005: '005' as LaenderschluesselEnum,
    _464: '464' as LaenderschluesselEnum,
    _732: '732' as LaenderschluesselEnum,
    _653: '653' as LaenderschluesselEnum,
    _108: '108' as LaenderschluesselEnum,
    _628: '628' as LaenderschluesselEnum,
    _463: '463' as LaenderschluesselEnum,
    _696: '696' as LaenderschluesselEnum,
    _302: '302' as LaenderschluesselEnum,
    _404: '404' as LaenderschluesselEnum,
    _247: '247' as LaenderschluesselEnum,
    _079: '079' as LaenderschluesselEnum,
    _644: '644' as LaenderschluesselEnum,
    _346: '346' as LaenderschluesselEnum,
    _083: '083' as LaenderschluesselEnum,
    _812: '812' as LaenderschluesselEnum,
    _833: '833' as LaenderschluesselEnum,
    _480: '480' as LaenderschluesselEnum,
    _375: '375' as LaenderschluesselEnum,
    _095: '095' as LaenderschluesselEnum,
    _092: '092' as LaenderschluesselEnum,
    _448: '448' as LaenderschluesselEnum,
    _636: '636' as LaenderschluesselEnum,
    _684: '684' as LaenderschluesselEnum,
    _395: '395' as LaenderschluesselEnum,
    _054: '054' as LaenderschluesselEnum,
    _604: '604' as LaenderschluesselEnum,
    _268: '268' as LaenderschluesselEnum,
    _216: '216' as LaenderschluesselEnum,
    _037: '037' as LaenderschluesselEnum,
    _055: '055' as LaenderschluesselEnum,
    _018: '018' as LaenderschluesselEnum,
    _743: '743' as LaenderschluesselEnum,
    _370: '370' as LaenderschluesselEnum,
    _386: '386' as LaenderschluesselEnum,
    _701: '701' as LaenderschluesselEnum,
    _667: '667' as LaenderschluesselEnum,
    _232: '232' as LaenderschluesselEnum,
    _046: '046' as LaenderschluesselEnum,
    _204: '204' as LaenderschluesselEnum,
    _824: '824' as LaenderschluesselEnum,
    _228: '228' as LaenderschluesselEnum,
    _373: '373' as LaenderschluesselEnum,
    _377: '377' as LaenderschluesselEnum,
    _023: '023' as LaenderschluesselEnum,
    _412: '412' as LaenderschluesselEnum,
    _147: '147' as LaenderschluesselEnum,
    _716: '716' as LaenderschluesselEnum,
    _097: '097' as LaenderschluesselEnum,
    _470: '470' as LaenderschluesselEnum,
    _366: '366' as LaenderschluesselEnum,
    _676: '676' as LaenderschluesselEnum,
    _389: '389' as LaenderschluesselEnum,
    _803: '803' as LaenderschluesselEnum,
    _672: '672' as LaenderschluesselEnum,
    _809: '809' as LaenderschluesselEnum,
    _804: '804' as LaenderschluesselEnum,
    _814: '814' as LaenderschluesselEnum,
    _432: '432' as LaenderschluesselEnum,
    _858: '858' as LaenderschluesselEnum,
    _003: '003' as LaenderschluesselEnum,
    _240: '240' as LaenderschluesselEnum,
    _288: '288' as LaenderschluesselEnum,
    _838: '838' as LaenderschluesselEnum,
    _820: '820' as LaenderschluesselEnum,
    _836: '836' as LaenderschluesselEnum,
    _028: '028' as LaenderschluesselEnum,
    _649: '649' as LaenderschluesselEnum,
    _038: '038' as LaenderschluesselEnum,
    _662: '662' as LaenderschluesselEnum,
    _825: '825' as LaenderschluesselEnum,
    _442: '442' as LaenderschluesselEnum,
    _801: '801' as LaenderschluesselEnum,
    _520: '520' as LaenderschluesselEnum,
    _504: '504' as LaenderschluesselEnum,
    _708: '708' as LaenderschluesselEnum,
    _813: '813' as LaenderschluesselEnum,
    _890: '890' as LaenderschluesselEnum,
    _060: '060' as LaenderschluesselEnum,
    _010: '010' as LaenderschluesselEnum,
    _318: '318' as LaenderschluesselEnum,
    _728: '728' as LaenderschluesselEnum,
    _074: '074' as LaenderschluesselEnum,
    _324: '324' as LaenderschluesselEnum,
    _066: '066' as LaenderschluesselEnum,
    _075: '075' as LaenderschluesselEnum,
    _499: '499' as LaenderschluesselEnum,
    _806: '806' as LaenderschluesselEnum,
    _378: '378' as LaenderschluesselEnum,
    _819: '819' as LaenderschluesselEnum,
    _810: '810' as LaenderschluesselEnum,
    _047: '047' as LaenderschluesselEnum,
    _311: '311' as LaenderschluesselEnum,
    _632: '632' as LaenderschluesselEnum,
    _030: '030' as LaenderschluesselEnum,
    _039: '039' as LaenderschluesselEnum,
    _248: '248' as LaenderschluesselEnum,
    _098: '098' as LaenderschluesselEnum,
    _094: '094' as LaenderschluesselEnum,
    _355: '355' as LaenderschluesselEnum,
    _264: '264' as LaenderschluesselEnum,
    _382: '382' as LaenderschluesselEnum,
    _706: '706' as LaenderschluesselEnum,
    _498: '498' as LaenderschluesselEnum,
    _479: '479' as LaenderschluesselEnum,
    _063: '063' as LaenderschluesselEnum,
    _091: '091' as LaenderschluesselEnum,
    _342: '342' as LaenderschluesselEnum,
    _011: '011' as LaenderschluesselEnum,
    _669: '669' as LaenderschluesselEnum,
    _329: '329' as LaenderschluesselEnum,
    _449: '449' as LaenderschluesselEnum,
    _465: '465' as LaenderschluesselEnum,
    _408: '408' as LaenderschluesselEnum,
    _467: '467' as LaenderschluesselEnum,
    _388: '388' as LaenderschluesselEnum,
    _224: '224' as LaenderschluesselEnum,
    _893: '893' as LaenderschluesselEnum,
    _225: '225' as LaenderschluesselEnum,
    _492: '492' as LaenderschluesselEnum,
    _393: '393' as LaenderschluesselEnum,
    _082: '082' as LaenderschluesselEnum,
    _736: '736' as LaenderschluesselEnum,
    _680: '680' as LaenderschluesselEnum,
    _626: '626' as LaenderschluesselEnum,
    _280: '280' as LaenderschluesselEnum,
    _839: '839' as LaenderschluesselEnum,
    _817: '817' as LaenderschluesselEnum,
    _472: '472' as LaenderschluesselEnum,
    _244: '244' as LaenderschluesselEnum,
    _061: '061' as LaenderschluesselEnum,
    _212: '212' as LaenderschluesselEnum,
    _052: '052' as LaenderschluesselEnum,
    _080: '080' as LaenderschluesselEnum,
    _454: '454' as LaenderschluesselEnum,
    _807: '807' as LaenderschluesselEnum,
    _350: '350' as LaenderschluesselEnum,
    _072: '072' as LaenderschluesselEnum,
    _064: '064' as LaenderschluesselEnum,
    _524: '524' as LaenderschluesselEnum,
    _400: '400' as LaenderschluesselEnum,
    _081: '081' as LaenderschluesselEnum,
    _816: '816' as LaenderschluesselEnum,
    _045: '045' as LaenderschluesselEnum,
    _484: '484' as LaenderschluesselEnum,
    _647: '647' as LaenderschluesselEnum,
    _006: '006' as LaenderschluesselEnum,
    _352: '352' as LaenderschluesselEnum,
    _690: '690' as LaenderschluesselEnum,
    _811: '811' as LaenderschluesselEnum,
    _834: '834' as LaenderschluesselEnum,
    _306: '306' as LaenderschluesselEnum,
    _600: '600' as LaenderschluesselEnum
};

